import { render, staticRenderFns } from "./efficiency-report.vue?vue&type=template&id=34f4f47a&"
import script from "./efficiency-report.vue?vue&type=script&lang=js&"
export * from "./efficiency-report.vue?vue&type=script&lang=js&"
import style0 from "./efficiency-report.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports